import { joinItems } from "views/landing/constants";
import Container from "../Container";
import SectionHeader from "../SectionHeader";
import JoinRuleCard from "./components/JoinRuleCard";
import LoopLine from "../LoopLine";
import { useEffect, useRef } from "react";
import { motion, useInView, useAnimation } from "framer-motion";

const JoinAgnt = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  const fadeUpVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut", delay: 0.5 },
    },
  };

  const joinContainerVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5,
      },
    },
  };

  const joinCardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <div ref={ref} className="relative">
      <motion.div
        ref={ref}
        initial="hidden"
        animate={controls}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              delay: 0.5,
              duration: 1,
              ease: "easeOut",
              staggerChildren: 0.3,
            },
          },
        }}
      >
        <Container
          animationControls={controls}
          sectionClasses="overflow-hidden pb-[9vw] max-lg:pb-[30vw]"
          ellipseClasses="-top-[70%]"
        >
          <SectionHeader
            title="Join AGNT.Hub"
            desc="How to get started"
            sectionHeaderClasses="mb-[80px] max-lg:mb-[12vw]"
          />

          <motion.div
            className="flex justify-center w-full gap-[14vw] max-lg:flex-col max-lg:gap-[12vw] max-lg:items-center"
            variants={joinContainerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            {joinItems.map(
              ({ title, icon, information, linkName, isBlueLine, url }) => (
                <motion.div key={title} variants={joinCardVariants}>
                  <JoinRuleCard
                    linkUrl={url}
                    title={title}
                    icon={icon}
                    information={information}
                    linkName={linkName}
                    isBlueLine={isBlueLine}
                  />
                </motion.div>
              )
            )}
          </motion.div>
        </Container>

        <div className="absolute left-[0px] rotate-[-5deg] -bottom-[2vw]">
          <motion.div variants={fadeUpVariants}>
            <LoopLine />
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default JoinAgnt;
